import React, { useRef, forwardRef, useImperativeHandle } from 'react';

import AMap from './AMap';
import BMap from './BMap';
import { MAP_TYPE } from '@helpers/Constants';

export { default as Marker } from './components/Marker';
export { default as CustomOverlay } from './components/CustomOverlay';
export { default as Polygon } from './components/Polygon';
// export { default as Circle } from './components/Circle';

interface IProps {
  type?: string;
  children: React.ReactNode;
  center?: any;
  onMapLoad?: () => void;
  zoom?: number;
  maxZoom?: number;
  minZoom?: number;
  enablePinchToZoom?: boolean;
  enableDoubleClickZoom?: boolean;
  onZoomEnd?: () => void;
  onTouchStart?: () => void;
  enableMouseTools?: boolean;
}

const BaseMap = (props: IProps, ref: any) => {
  const mapRef = useRef(null);
  const ContentMap = {
    bMap: BMap,
    aMap: AMap,
  };
  useImperativeHandle(ref, () => ({
    mapRef: () => mapRef.current,
    ...mapRef.current,
  }));

  const mapLoad = () => {
    props.onMapLoad && props.onMapLoad();
  };
  const Content = ContentMap[props.type || MAP_TYPE];
  return <Content {...props} onMapLoad={mapLoad} ref={mapRef} />;
};

export default forwardRef(BaseMap);
